import React from 'react'

const CarouselComponent = props => {
    const { Renderer } = props

    return <Renderer {...props} />
}

export default CarouselComponent
